<script>
export default {
  methods: {
    nameFromEmailAddress: function(emailAddress) {
      // Sometimes we only have an email for some reason. Try and get name from dot-separated local part of email
      const fullName = emailAddress.split('@')[0].split('.');
      const firstName = fullName[0].charAt(0).toUpperCase() + fullName[0].slice(1);
      const lastName = fullName[ fullName.length-1 ].charAt(0).toUpperCase() + fullName[ fullName.length-1 ].slice(1); 

      return `${firstName} ${lastName}`;
    },
    readableList: function(list) {
      let returnVal = '';
      for(let i=0; i<list.length; i++) {
        returnVal += list[i];

        if(i<list.length-2) {
          returnVal += ', ';
        } else if(i==list.length-2) {
          returnVal += ' and ';
        }
      }

      return returnVal;
    }
  }
}
</script>